import { render, staticRenderFns } from "./UnavailabilityIntervalsListTable.vue?vue&type=template&id=583385ba&"
import script from "./UnavailabilityIntervalsListTable.vue?vue&type=script&lang=ts&"
export * from "./UnavailabilityIntervalsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports